import { storeContext } from "#storeContext.ts";
import { CommandDialog } from "@momentum/dev-tools";
import {
  createStore,
  Provider
} from "@momentum/redux-store";
import {
  Outlet,
  type LoaderFunction,
  type MiddlewareFunction,
} from "react-router";
import { Toast } from "radix-ui";
import { initSw, swSlice } from "#slices/swSlice.ts";
import { ServiceWorkerToast } from "#routes/app/ServiceWorkerToast.tsx";
import { setupListeners } from "@reduxjs/toolkit/query";
const store = createStore();
setupListeners(store.dispatch);

if (import.meta.env.DEV) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).STORE = store;
}

const storeMiddleware: MiddlewareFunction = ({ context }) => {
  context.set(storeContext, store);
};

export const loader: LoaderFunction = async ({ context }) => {
  const store = context.get(storeContext);
  if (swSlice.selectSlice(store.getState()).status.status === "initial") {
    store.dispatch(initSw());
  }
  return null;
};

export const middleware = [storeMiddleware];

function AppRoute() {
  return (
    <Provider store={store}>
      <Toast.Provider>
        <Outlet />
        <ServiceWorkerToast />
        <CommandDialog />
        <Toast.Viewport className="fixed bottom-0 right-0 z-[2147483647] m-0 flex w-[390px] max-w-[100vw] list-none flex-col gap-2.5 p-[var(--viewport-padding)] outline-none [--viewport-padding:_25px]" />
      </Toast.Provider>
    </Provider>
  );
}

export { AppRoute as Component };

export function HydrateFallback() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-main-bg">
      <div className="relative">
        {/* Outer rotating ring */}
        <div className="w-16 h-16 border-4 border-grey-80/20 border-t-peri-blue rounded-full animate-spin" />
        {/* Inner pulsing dot */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-3 h-3 bg-peri-blue rounded-full animate-pulse" />
        </div>
        {/* Glow effect */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-3 h-3 bg-peri-blue rounded-full opacity-50 animate-ping" />
        </div>
      </div>
    </div>
  );
}
